import { Box } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { isBhiAdmin } from 'src/helpers/permissions';
import { AccessDeniedView } from 'src/modules/authentication/components';
import { selectProfile } from 'src/modules/profile/slices';

const AdminViewWrapper: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const { profile } = useSelector(selectProfile);

  if (!profile) {
    return null;
  }

  if (!isBhiAdmin(profile)) {
    return <AccessDeniedView />;
  }

  return <Box sx={{ width: "100%" }}>{children}</Box>;
};

export default AdminViewWrapper;
